import { EU_COUNTRY_CODES, ADDITIONAL_GDPR_COUNTRIES } from './constants/countries';
/**
 * Checks if country is regulated by GDPR
 * @param {String} ISOTwoLetterCountryCode
 * @return {Boolean}
 */

export function isGDPRCountry(ISOTwoLetterCountryCode) {
  if (!ISOTwoLetterCountryCode) return false;
  var countryCodeUpperCase = ISOTwoLetterCountryCode.toUpperCase();
  return isEuropeanUnionCountry(countryCodeUpperCase) || ADDITIONAL_GDPR_COUNTRIES.includes(countryCodeUpperCase);
}
/**
 * Checks if a country code is in the European Union
 * @param  {String}  ISOTwoLetterCountryCode
 * @return {Boolean}
 */

function isEuropeanUnionCountry(ISOTwoLetterCountryCode) {
  return EU_COUNTRY_CODES.includes(ISOTwoLetterCountryCode.toUpperCase());
}